import type { Configuration, ViewsConfiguration } from "./Configuration"

const defaultConfiguration: Configuration = {
  isUsedOnBorne: true,
  enableConversationCookie: false,
  allowSwitchLayout: false,
  preventVirtualKeyboard: true
};

const defaultViewsConfiguration: ViewsConfiguration = {
  homeRoute: 'home',
  views: {
    home: {
      background: {
        image: undefined,
        video: undefined,
        webcam: undefined,
        neutral: undefined,
        style: 'image'
      }
    },
    news: {
      openingVideo: 'videos/news/intro.mp4',
      background: {
        style: 'image',
        image: undefined
      }
    }
  }
}

export { defaultConfiguration, defaultViewsConfiguration };
